import React from 'react'
import propTypes from 'prop-types'

export default function Header(props){
  return(
     <nav className="navbar navbar-expand-md navbar-dark bg-dark">
    <div className="container-fluid">
        <div className="navbar-brand text-success fw-bold">{props.title}</div>
        <button className="navbar-toggler m-2" type="button" data-bs-toggle="collapse" data-bs-target="#mynavbar" aria-controls="mynavbar" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="mynavbar">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                <li className="nav-item">
                    <a href="/" className="nav-link active" >{props.home}</a>
                </li>
                <li className="nav-item">
                    <a href="/about" className="nav-link">About</a>
                </li>
            </ul>
            <form className="d-flex">
                <input className="form-control me-2" type="text" placeholder="Search" aria-label="Search" />
                <button className="btn btn-success" type="button">Search</button>
            </form>
        </div>
    </div>
</nav>
    )
}
Header.defaultProps = {
  title : "Todo-list"
}
Header.propTypes = {
  title : propTypes.string.isRequired
}